/*
 * Copyright Huesik (c) 2019.
 */


export default {
  SERVER: {
    // DEVELOPMENT: 'http://192.168.0.44:3001/api/',
    DEVELOPMENT: 'http://localhost:3001/api/',
    PRODUCTION: 'https://api.kosirock.co.kr/api/'
  },
  API_KEY: {
    GOOGLE_MAPS: 'AIzaSyBNPPfxSFu6y4IkQ8R_yhdL8N6DntxBFSg'
  },
  DOMAIN: {
    DEVELOPMENT: 'localhost:8081',
    PRODUCTION: 'kosirock.com'
  }

}
